import React, { useState } from "react";
import PropTypes from "prop-types";
import { 
  Tabs, 
  Tab, 
  Typography, 
  Box, 
  Grid,
  useTheme,
  useMediaQuery,
  Paper,
} from "@mui/material";
import { 
  Person,
  Lock
} from '@mui/icons-material';
import ProfileForm from "./ProfileForm";
import ChangePasswordForm from "./ChangePasswordForm";
import axios from "axios";
import { ROUTES } from "../single-page/constants/routes";

function TabPanel({ children, value, index, ...other }) {
  return (
    <Box
      sx={{ 
        width: "100%",
        height: "100%"
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box 
          sx={{ 
            p: { xs: 2, sm: 3 },
            height: "100%"
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const tabs = [
  {
    label: "Editar Perfil",
    icon: <Person />,
    component: ProfileForm
  },
  {
    label: "Trocar Senha",
    icon: <Lock />,
    component: ChangePasswordForm
  }
];

export default function VerticalMenu({ currentUser }) {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const updateUser = async (user, address) => {
    try {
      return await axios.put(ROUTES.UPDATE_USER, {
        user: {
          name: user.name,
          last_name: user.last_name,
          email: user.email,
          phone: user.phone,
          password: user.password,
          password_confirmation: user.password_confirmation,
          current_password: user.current_password,
          billing_address: {
            zip_code: address?.zipCode,
            address: address?.street,
            number: address?.number,
            complement: address?.complement,
            neighborhood: address?.neighborhood,
            city: address?.city,
            state: address?.state
          },
        },
      });
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error);
      throw error;
    }
  };

  return (
    <Paper 
      elevation={2}
      sx={{ 
        flexGrow: 1,
        bgcolor: "#fff",
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid rgba(0, 0, 0, 0.08)'
      }}
    >
      <Grid 
        container 
        sx={{
          minHeight: { xs: 'auto', md: "600px" },
        }}
      >
        <Grid 
          item 
          xs={12} 
          md={3}
          sx={{
            bgcolor: '#FFFFFF',
            borderRight: { 
              xs: 'none', 
              md: "1px solid rgba(0, 0, 0, 0.08)" 
            },
            borderBottom: {
              xs: "1px solid rgba(0, 0, 0, 0.08)",
              md: 'none'
            }
          }}
        >
          <Tabs
            orientation={isMobile ? "horizontal" : "vertical"}
            variant="fullWidth"
            value={value}
            onChange={handleChange}
            aria-label="Menu de configurações"
            sx={{
              minHeight: { xs: 'auto', md: '100%' },
              "& .MuiTabs-indicator": {
                bgcolor: "#3232B2",
                ...(isMobile && {
                  height: 3
                })
              },
              "& .MuiTab-root": {
                minHeight: 72,
                fontSize: { xs: 16, sm: 18 },
                fontWeight: "bold",
                textTransform: "none",
                color: "rgba(0, 0, 0, 0.7)",
                "&.Mui-selected": {
                  color: "#3232B2",
                  bgcolor: '#fff'
                },
                "&:hover": {
                  bgcolor: 'rgba(255, 255, 255, 0.7)',
                  transition: 'background-color 0.2s'
                }
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab 
                key={tab.label}
                label={tab.label}
                icon={tab.icon}
                iconPosition="start"
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </Grid>

        <Grid 
          item 
          xs={12} 
          md={9}
          sx={{
            bgcolor: '#fff',
            minHeight: { xs: 'auto', md: '600px' }
          }}
        >
          {tabs.map((tab, index) => (
            <TabPanel key={index} value={value} index={index}>
              <tab.component
                updateUser={updateUser}
                currentUser={currentUser}
              />
            </TabPanel>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
}

function a11yProps(index) {
  return {
    id: `settings-tab-${index}`,
    "aria-controls": `settings-tabpanel-${index}`,
  };
}

VerticalMenu.propTypes = {
  currentUser: PropTypes.object.isRequired
};
